import SpinnerIcon from './component.jsx'
export default SpinnerIcon
